var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-canvas-edit-link-button",on:{"click":_vm.editLink}},[_vm._v("Edit Link")])
}
var staticRenderFns = []

export { render, staticRenderFns }